// How the money came in — ONE list for the whole panel.
//
// There used to be four: the counter form offered 4 modes, the payments page
// 8, the supervisor editor 6. That is not a cosmetic split. The counter form
// treated any mode outside its own four as unknown and reset it to CASH on
// save — so opening a GPay sale to fix a typo in the customer's name recorded
// it as cash, with nothing to say it had happened. A sale is paid by what it
// was paid by; the list that renders it must be the list that stores it.
//
// These eight are the backend's own (CustomerInquiry.PAYMENT_MODE_CHOICES),
// and counter sales now validate against them too. Cars speak a superset —
// loans and cheques — so they get CAR_PAYMENT_MODES below, never this list.

export const PAYMENT_MODES = [
  { v: 'cash', l: 'Cash' },
  { v: 'card', l: 'Card' },
  { v: 'gpay', l: 'GPay' },
  { v: 'phonepe', l: 'PhonePe' },
  { v: 'paytm', l: 'Paytm' },
  { v: 'upi', l: 'UPI' },
  { v: 'bank_transfer', l: 'Bank Transfer' },
  { v: 'other', l: 'Other' },
];

/** Same list in the {value,label} shape the older <Select> components take. */
export const PAYMENT_MODE_OPTIONS = PAYMENT_MODES.map((m) => ({ value: m.v, label: m.l }));

export const MODE_LABELS = Object.fromEntries(PAYMENT_MODES.map((m) => [m.v, m.l]));

/** Code → words. An unrecorded mode reads as '', a legacy one as itself. */
export const modeLabel = (code) => {
  const key = String(code || '').toLowerCase();
  return MODE_LABELS[key] || (code ? String(code).replace(/_/g, ' ') : '');
};

/** Is this a mode the backend will accept? ('' means "not recorded", which is legal.) */
export const isKnownMode = (code) => Boolean(MODE_LABELS[String(code || '').toLowerCase()]);

// ── Cars ─────────────────────────────────────────────────────────────────────
// Whole cars are bought with money the parts counter never sees: bank loans
// and cheques. Same eight modes plus those two — and 'bank', the word the old
// car form used for a transfer, kept readable so old sales don't show a code.

export const CAR_PAYMENT_MODES = [
  ...PAYMENT_MODES,
  { v: 'loan', l: 'Bank loan / finance' },
  { v: 'cheque', l: 'Cheque' },
];

export const CAR_PAYMENT_MODE_OPTIONS = CAR_PAYMENT_MODES.map((m) => ({ value: m.v, label: m.l }));

const CAR_MODE_LABELS = {
  ...Object.fromEntries(CAR_PAYMENT_MODES.map((m) => [m.v, m.l])),
  bank: 'Bank Transfer',    // legacy value from the first car form
};

export const carModeLabel = (code) => {
  const key = String(code || '').toLowerCase();
  return CAR_MODE_LABELS[key] || (code ? String(code).replace(/_/g, ' ') : '');
};

/** Modes where the money has a bank behind it — the receipt asks whose. */
export const MODE_NEEDS_BANK = new Set(['loan', 'cheque', 'bank_transfer']);
